import { Drawer } from "@mui/material";
import { memo, ReactNode } from "react";
import {
  RedoButtonCloseX,
  ButtonSize as XButtonSize,
} from "../redo-button-close-x";

/**
 * @param onModalCloseRequested - Called when x clicked, the user presses escape, or clicks away
 * @param showCloseButton - Whether to show the X close button in the top right (default: false)
 */
export interface RedoDrawerProps {
  children?: ReactNode | undefined;
  onModalCloseRequested(): void;
  ref?: React.RefObject<HTMLElement>;
  showCloseButton?: boolean;
  uiSelector?: string;
}

export const RedoDrawer = memo(function RedoDrawer({
  children,
  onModalCloseRequested,
  showCloseButton = false,
  uiSelector,
}: RedoDrawerProps) {
  return (
    <Drawer
      anchor="right"
      data-ui={uiSelector}
      onClose={onModalCloseRequested}
      open
    >
      {showCloseButton && (
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 1,
          }}
        >
          <RedoButtonCloseX
            onclick={onModalCloseRequested}
            onDarkBackground={false}
            size={XButtonSize.XSMALL}
          />
        </div>
      )}
      {children}
    </Drawer>
  );
});
